import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const AuditContext = createContext()

const AuditProvider = ({ children }) => {

    const { auth, toast } = useAuth();

    const headers = {
        Authorization: auth?.token,
    };

    const getAllAudits = async (filter) => {
        try {
            const { page, search, limit } = filter

            let { data } = await axios.get(`${baseURL}/admin/user/audit?filter=${search ? search : null}&limit=${limit ? limit : null}&page=${page ? page : null}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })

        }
    }

    return (
        <AuditContext.Provider value={{ getAllAudits }}>
            {children}
        </AuditContext.Provider>
    )
}

const useAudit = () => useContext(AuditContext)

export { useAudit, AuditProvider }